import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';

import * as ColumnsAliasesActions from './columns-aliases.actions';
import { ColumnsAliasesService } from '../../services/columns-aliases.service';
import * as AuthActions from '../../auth/store/actions/auth.actions';

@Injectable()
export class ColumnsAliasesEffects {

  public getUsersInvites$ = createEffect(() => {
    return this._actions.pipe(
      ofType(ColumnsAliasesActions.getColumnsAliases),
      switchMap(() => {
        return this._columnsAliasesService.getColumnsAliases()
          .pipe(
            switchMap((columnsAliases) => of(
              ColumnsAliasesActions.getColumnsAliasesSuccess({ columnsAliases }),
            ),
          ),
        )
      }),
    )
  });

  public createAlias$ = createEffect(() => {
    return this._actions.pipe(
      ofType(ColumnsAliasesActions.createAlias),
      switchMap(({ attribute, alias }) => {
        return this._columnsAliasesService.createAlias(attribute, alias)
          .pipe(
            switchMap(() => of(
                ColumnsAliasesActions.createAliasSuccess,
                ColumnsAliasesActions.removeCreateMode(),
                ColumnsAliasesActions.getColumnsAliases(),
              ),
            ),
          )
      }),
    )
  });

  public editAlias$ = createEffect(() => {
    return this._actions.pipe(
      ofType(ColumnsAliasesActions.editAlias),
      switchMap(({ id, attribute, alias }) => {
        return this._columnsAliasesService.editAlias(id, attribute, alias)
          .pipe(
            switchMap((columnAlias) => of(
              ColumnsAliasesActions.editAliasSuccess(columnAlias),
              ColumnsAliasesActions.getColumnsAliases(),
            ),
          ),
        )
      }),
    )
  });

  public deleteAlias$ = createEffect(() => {
    return this._actions.pipe(
      ofType(ColumnsAliasesActions.deleteAlias),
      switchMap(({ id }) => {
        return this._columnsAliasesService.deleteAlias(id)
          .pipe(
            switchMap(() => of(
                ColumnsAliasesActions.deleteAliasSuccess(),
                ColumnsAliasesActions.getColumnsAliases(),
              ),
            ),
          )
      }),
    )
  });

  public clearStore$ = createEffect(() => {
    return this._actions.pipe(
      ofType(AuthActions.logout),
      switchMap(() => of(ColumnsAliasesActions.clearStore())),
    )
  });

  constructor(
    private _actions: Actions,
    private _columnsAliasesService: ColumnsAliasesService,
  ) {}
}
